import React, { Component } from 'react';
import './Segment.css';

class Segment extends Component {
  constructor(props) {
    super();
    this.id = props.id;
    this.headline = props.headline;
    this.subHeadline = props.subHeadline;
    this.description = props.description;
    this.img = props.img;
    this.video = props.video;
    this.buttons = props.buttons;
    this.buttonComment = props.buttonComment;
    this.width = props.width;
    this.intro = props.intro;
  }

  render() {
    const segmentIntro = this.intro ?
      <p className='segment-intro' id={this.id}>{this.intro}</p> : null;

    const buttonComment = this.buttonComment ?
      <p className="button-comment">{this.buttonComment}</p> : null;

    const buttons = this.buttons ?
      this.buttons.map(button =>
        <a
          key={button.href}
          className="btn btn-outline-secondary"
          target="_blank"
          href={button.href}
          role="button"
        >{button.title}</a>) : null;

    const style = {
      backgroundImage: `url(${this.img})`,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center top',
      ...this.id === 'contact' && { height: '560px' },
    };

    const video =  this.video ?
      <video autoPlay loop muted playsInline>
        <source src={this.video} type="video/mp4" />
        Your browser does not support the video tag.
      </video> : null;

    const header = this.video ? video :
      <div className="image" style={style}></div>


    return (
      <div className={`col-lg-${this.width}`}>
        {segmentIntro}
        <div className="segment">
          {header}
          <h2>{this.headline}</h2>
          <p>{this.description}</p>
          <div className="text-center">
            {buttons}
            {buttonComment}
          </div>
        </div>
      </div>
    );
  }
}

export default Segment;



// WEBPACK FOOTER //
// ./src/segment/Segment.js